var cardSliders = document.querySelectorAll('.card-swiper');

var initCardSlider = (item) => {
  let options = {
    navigation: {
      nextEl: item.parentElement.parentElement.querySelector('.card-swiper-nav__next'),
      prevEl: item.parentElement.parentElement.querySelector('.card-swiper-nav__prev'),
    },
    loop: false,
    speed: 500,
    observer: true,
    observeParents: true,
    iOSEdgeSwipeDetection: true,
    iOSEdgeSwipeThreshold: 0,
    simulateTouch: true,
    preventInteractionOnTransition: true,
    slidesPerView: 'auto',
    height: 'auto',
    centeredSlides: false,
    spaceBetween: 20,
    breakpoints: {
      992: {
        spaceBetween: 30,
      },
    },
  };

  var cardSwiper = new Swiper(item, options);
};

cardSliders.forEach((item, i) => {
  initCardSlider(item);
});
